import { useEffect, useRef, useState } from "react";
import { Card } from "../general/card";
import { Text } from "../general/typography";
import Loader from "../../components/general/loader";
import { Box, Divider, IconButton } from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import { ChartErrorBoundary } from "./chart_error_boundary";
import { ChartIdProvider } from "./chart_id_context";

export function ChartCard({ data, Chart, title, subtitle, isLoading, noDataMessage, info = null }) {
  const containerRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleChange = () => {
      setIsFullscreen(document.fullscreenElement === containerRef.current);
    };
    document.addEventListener("fullscreenchange", handleChange);
    return () => document.removeEventListener("fullscreenchange", handleChange);
  }, []);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      containerRef.current?.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };
  const hasData = Array.isArray(data) ? data.length > 0 : !!data;

  const NoData = (
    <Text sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      {noDataMessage || "No data available"}
    </Text>
  );

  return (
    <Box ref={containerRef} sx={{ backgroundColor: isFullscreen ? "white" : "transparent", borderRadius: 3 }}>
      <Card
        key={title}
        title={title}
        subtitle={subtitle}
        info={info}
        action={
          <IconButton size="small" onClick={toggleFullscreen} sx={{ ml: 1 }}>
            {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </IconButton>
        }
      >
        <Box sx={{ height: isFullscreen ? "calc(100vh - 120px)" : 300 }}>
          {isLoading ? (
            <Loader />
          ) : hasData ? (
            <ChartErrorBoundary>
              <ChartIdProvider value={title}>{Chart}</ChartIdProvider>
            </ChartErrorBoundary>
          ) : (
            NoData
          )}
        </Box>
      </Card>
    </Box>
  );
}

export function ChartDivider({ data, Chart, title, isLoading }) {
  const cardSx = { height: 370, pb: 7, border: "0px" };

  const hasData = Array.isArray(data) ? data.length > 0 : !!data;

  const NoData = (
    <Text sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>No data available</Text>
  );

  return (
    <Card sx={cardSx} title={title}>
      {isLoading ? <Loader /> : hasData ? <ChartErrorBoundary>{Chart}</ChartErrorBoundary> : NoData}
      {isLoading ? <Loader /> : hasData ? <Divider /> : null}
    </Card>
  );
}
